export const showTourModal = (
	show: boolean,
	url: string,
): Media.ShowTourModal => {
	return {
		type: 'media/TOUR_MODAL',
		payload: { show, url },
	};
};
